import React from "react";
import "./Aboutpage.css";
import PageBanner from "../components/PageBanner";
import bannerimg from "../../media/bannerimg.jpg";

import aboutimg from "../../media/ceoimg.png";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import leftimg from "../../media/ceoimg.jpeg";

import CEOImage from "../../media/ceoimg.jpg";
import TeamImage from "../../media/aboutpageimgg.jpg";
import icon1 from "../../media/serviceicon.png";
import aboutimage from "../../media/imageabout.jpg";
// New: Corner images
import bgTopLeft from "../../media/aboutserviceimg1.png";
import bgTopRight from "../../media/aboutserviceimg3.png";
import bgBottomLeft from "../../media/aboutserviceimg2.png";
import bgBottomRight from "../../media/aboutserviceimg4.png";
import aboutpageimg2 from "../../media/aboutimgone.jpg";
import ExpansionSection from "../Homepage/ExpansionSection";

import MissionVision from "../Homepage/Mission";
import usePageTitle from "../components/usePageTitle";

const Aboutpage = () => {
  usePageTitle("About");
  return (
    <div>
      <PageBanner title="About Us" breadcrumb="About Us" bgImage={bannerimg} />
      <section className="about-page-main">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT IMAGES */}
            {/* LEFT IMAGES */}
            <div className="col-lg-6 about-page-image-wrapper d-flex justify-content-center">
              <div className="about-page-image-stack position-relative">
                {/* Bottom (larger) image */}
                <div className="about-page-image-box-bottom position-relative shadow rounded-4 overflow-hidden">
                  <img
                    src={aboutimage}
                    alt="Bottom - CEO"
                    className="about-page-image img-fluid"
                  />
                </div>

                {/* Top (smaller) image overlapping bottom */}
                <div className="about-page-image-box-top position-absolute shadow rounded-4 overflow-hidden">
                  <img
                    src={TeamImage}
                    alt="Top - Team"
                    className="about-page-image img-fluid"
                  />
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-6 about-page-content-wrapper mt-5 mt-lg-0 ps-lg-5">
              <div className="about-page-subtitle-wrapper mb-2">
                <p className="about-page-subtitle text-uppercase text-primary fw-bold">
                  About Our Company
                </p>
              </div>

              <div className="about-page-title-wrapper mb-3">
                <h2 className="about-page-title fw-bold">
                  We’ll Ensure You Always Get <br />
                  the<span className="about-page-green"> Best Guidance </span>
                </h2>
              </div>

              <div className="about-page-paragraph-wrapper mb-4">
                <p className="about-page-description">
                  Prior to his leadership in higher education, RC held senior
                  financial roles within the U.S. federal government, where he
                  gained extensive experience in policy development, compliance,
                  and cross-agency collaboration. As a Southern Nevada Public
                  Land Management Act (SNPLMA) Accountant, he managed and
                  tracked over $3 billion in federally funded projects that
                  supported land acquisition, environmental restoration,
                  infrastructure improvements, and recreational development
                  across multiple western states. His work ensured proper
                  allocation, audit readiness, and reporting compliance for one
                  of the most impactful land management programs in the nation.
                  He was recognized as a rising leader through his selection to
                  the Bureau of Land Management’s Emerging Leader Program (2025
                  Cohort) - a competitive program for developing future
                  executives in federal service.
                </p>
              </div>

              <div className="d-flex flex-wrap align-items-center gap-4 mb-4 about-contact-block">
                <div className="d-flex align-items-center gap-2">
                  <div className="about-icon-box">
                    <i className="bi bi-telephone fs-4 text-primary"></i>
                  </div>
                  <div>
                    <small className="text-uppercase text-muted d-block">
                      Call To Ask Any Query
                    </small>
                    <strong>720-412-7990</strong>
                  </div>
                </div>

                <div className="about-divider"></div>

                <div className="d-flex align-items-center gap-2">
                  <img
                    src={leftimg}
                    alt="RC Panta"
                    className="ceo-img-about"
                    width="50"
                    height="50"
                  />
                  <div>
                    <small className="text-uppercase text-muted d-block">
                      Co-Founder & CEO
                    </small>
                    <strong>RC Panta</strong>
                  </div>
                </div>
              </div>
              <div className="about-page-button-wrapper d-flex flex-wrap gap-3">
                <a
                  href="#about-founder"
                  className="about-page-btn btn btn-primary px-4 py-2"
                >
                  READ MORE
                </a>
                <Link
                  to="/contact"
                  className="about-page-btn btn btn-outline-primary px-4 py-2"
                >
                  GET START NOW
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="about-founder"
        className="about-founder-wrapper container my-5"
      >
        <div className="row align-items-center about-founder-card  rounded-4 overflow-hidden ">
          {/* Left: Image */}
          <div className="col-md-5 about-founder-image-wrapper p-0">
            <img
              src={aboutimg}
              alt="RC Panta"
              className="about-founder-image img-fluid"
            />
          </div>

          {/* Right: Content */}
          <div className="col-md-7 p-4 about-founder-content">
            <h3 className="about-founder-name">RC Panta</h3>
            <p className="about-founder-title">Co-Founder & CEO</p>

            <p className="about-founder-description">
              RC began his career in Colorado’s higher education system, where
              he spent nearly a decade supporting grant management, capital
              asset reporting, and compliance auditing. His early work laid the
              foundation for his strength in navigating state and federal
              regulatory frameworks, streamlining accounting systems, and
              leading financial system upgrades that improved data transparency
              and decision-making.
            </p>
            <p className="about-founder-description">
              With a passion for public service, fiscal accountability, and
              organizational transformation, RC continues to be a trusted
              advisor and problem-solver in complex financial environments. His
              approach combines technical expertise with strategic vision,
              helping institutions move confidently toward financial
              sustainability and operational excellence.
            </p>

            <div className="row about-founder-details mt-4">
              {/* Experience */}
              <div className="col-6 mb-3 about-founder-detail d-flex align-items-start">
                <div className="about-founder-icon-box d-flex align-items-center justify-content-center">
                  <i className="bi bi-briefcase-fill about-founder-icon"></i>
                </div>
                <div>
                  <small className="about-founder-label">Experience</small>
                  <p className="about-founder-value">More Than 13 Years</p>
                </div>
              </div>

              {/* Phone */}
              <div className="col-6 mb-3 about-founder-detail d-flex align-items-start">
                <div className="about-founder-icon-box d-flex align-items-center justify-content-center">
                  <i className="bi bi-telephone-fill about-founder-icon"></i>
                </div>
                <div>
                  <small className="about-founder-label">Phone</small>
                  <p className="about-founder-value">720-412-7990</p>
                </div>
              </div>

              {/* Email */}
              <div className="col-6 mb-3 about-founder-detail d-flex align-items-start">
                <div className="about-founder-icon-box d-flex align-items-center justify-content-center">
                  <i className="bi bi-envelope-fill about-founder-icon"></i>
                </div>
                <div>
                  <small className="about-founder-label">Email</small>
                  <p className="about-founder-value">
                    aspensrbusinesssolutions @gmail.com
                  </p>
                </div>
              </div>

              {/* Education */}
              <div className="col-6 mb-3 about-founder-detail d-flex align-items-start">
                <div className="about-founder-icon-box d-flex align-items-center justify-content-center">
                  <i className="bi bi-mortarboard-fill about-founder-icon"></i>
                </div>
                <div>
                  <small className="about-founder-label">Education</small>
                  <p className="about-founder-value">
                    MBA, Eastern New Mexico University <br />
                    BS, Univ. of Colorado Denver
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="work-process-section py-5">
        <img
          src={bgTopLeft}
          alt=""
          className="work-process-bg-img bg-top-left"
        />
        <img
          src={bgTopRight}
          alt=""
          className="work-process-bg-img bg-top-right"
        />
        <img
          src={bgBottomLeft}
          alt=""
          className="work-process-bg-img bg-bottom-left"
        />
        <img
          src={bgBottomRight}
          alt=""
          className="work-process-bg-img bg-bottom-right"
        />

        <div className="container main-content-service text-center">
          {/* Section Heading */}
          <div className="work-process-header mb-5">
            <span className="work-process-subtitle text-uppercase fw-bold">
              At Aspen SR Business Solutions
            </span>
            <h2 className="work-process-title fw-bold mt-2">
              We Specialize In
            </h2>
          </div>

          {/* Step Items */}
          <div className="row justify-content-center gy-5">
            {[
              {
                icon: "bi-graph-up", // Bootstrap icon class
                number: "01",
                title: "Financial Reporting & Analysis",
                desc: "Specializing in federal, state, and GAAP-compliant financial statements and performance analysis.",
              },
              {
                icon: "bi-cash-stack",
                number: "02",
                title: "Budget Planning & Forecasting",
                desc: "Helping organizations build accurate budgets and realistic financial forecasts for strategic growth.",
              },
              {
                icon: "bi-shield-check",
                number: "03",
                title: "Internal Controls & Compliance",
                desc: "Conducting reviews and implementing systems to ensure strong governance and regulatory adherence.",
              },
              {
                icon: "bi-journal-check",
                number: "04",
                title: "Grant & Fund Accounting",
                desc: "Supporting accurate tracking, reporting, and management of restricted and unrestricted funds.",
              },
              {
                icon: "bi-box-seam",
                number: "05",
                title: "Asset Management & Systems",
                desc: "Managing assets and implementing efficient financial systems tailored to each organization’s needs.",
              },
              {
                icon: "bi-people",
                number: "06",
                title: "Business Consulting",
                desc: "Providing strategic financial guidance for nonprofits, educational institutions, and startup ventures.",
              },
            ].map((step, index) => (
              <div key={index} className="col-md-6 col-lg-4 work-process-step">
                <div className="work-process-step-circle mx-auto position-relative d-flex justify-content-center align-items-center">
                  <i className={`bi ${step.icon} work-process-icon`}></i>
                  <span className="work-process-step-number">
                    {step.number}
                  </span>
                </div>
                <h3 className="work-process-step-title mt-4">{step.title}</h3>
                <p className="work-process-step-text">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="mission-vision-section">
        <MissionVision />
      </section>
      <section className="expansion-section-about">
        <ExpansionSection />
      </section>
    </div>
  );
};

export default Aboutpage;
